import { Component, OnInit, Injectable, ViewChild } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PopupComponent } from './../../components/popup/popup.component';

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
import { GenericpopupComponent } from 'src/app/v2/components/genericpopup/genericpopup.component';
import { LoggerService } from 'src/app/logger.service';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})

@Injectable({
  providedIn: 'root'
})
export class LoginPage implements OnInit {

  isLoading = false;
  isLogin = true;
  isEmailValid = false;
  isNewOrGuest = true;
  emailValue = "";
  passwordValue = "";
  constructor(private loginService: LoginService, private logger:LoggerService, private modalCtrl: ModalController, private router: Router, public translator:TranslatorService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    //console.log("[login.page.ts] ionViewWillEnter()")

  }

  recoverPassword() {
    this.loginService.findAccount(this.emailValue)
  }

  loginWithGuest() {
    this.loginService.authenticate(null, null, false, true);
  }
  createAccount() {
    this.router.navigateByUrl("auth/tabs/signup");
  }
  validateEmail(num) {
    if (num.indexOf('@') !== -1 && num.length > 4) {
      this.isEmailValid = true;
    }
    else {
      this.isEmailValid = false;
    }
    this.isNewOrGuest = num.length === 0;
  }
  openError(error) {
    var errorMessage = "";
    let errorInternalCode: number = -1;
    var errorCode = error.code;
    var errorMessage = "";

    switch (error) {
      case "auth/user-not-found":
      case "auth/invalid-email":
        errorMessage = "Nu există un cont asociat acestei adrese de e-mail."
        break;
      case "auth/wrong-password":
        errorInternalCode = 1;
        errorMessage = "Parola introdusă este greșită. Pentru a reseta parola, introduce numele de utilizator in ecranul următor și apasă Recuperare parolă!";
        break;
      default:
        errorInternalCode = -1;
        errorMessage = "Am întâmpinat o eroare, te rugăm să ne contactezi prin email. Codul de eroare este: " + errorCode;
        break;
    }
    this.modalCtrl.create({ component: PopupComponent, componentProps: { pageId: 2, results: errorInternalCode, assetHeight: 0, errorMessage: errorMessage, loginService: this.loginService }, backdropDismiss: false }).then(modalEl => {
      modalEl.present();
      modalEl.onDidDismiss().then(result => {
        if (result.role === "recover") {
          //this.loginService.recoverPassword(email);
        }
        else if (result.role === "createaccount") {
          this.router.navigateByUrl("auth/tabs/signup");
        }
      })
    })
  }

  loginWithPassword() {
    let userData = this.loginService.userIsAuthenticated;
    this.logger.customLog("[storage.service.ts] setExamData()");
    if (userData != null && userData.email && userData.email.length > 0 && userData.email === this.emailValue) {
      this.loginService.authenticate(userData, "");
      //this.router.navigateByUrl("/home/tabs/shop");
      return;
    }
    if (this.emailValue === null || this.emailValue.length === 0 || this.passwordValue.length === 0) {
      return;
    }
    let isEmailAccount: boolean = this.emailValue.indexOf("@") != -1;
    if (isEmailAccount) {
      this.loginService.login(this.emailValue, this.passwordValue).then((error) => {
        if (error.code === undefined) { return; }
        this.openError(error.code)
      });
    }
    else {
      //TODO authenticate with user name
      this.loginService.loginWithUser(this.emailValue, this.passwordValue);
    }
  }
  onSubmit(ev: any) {

    return;
    let email: string = ev.form.value.email;
    let password = ev.form.value.password;
    let userData = this.loginService.userIsAuthenticated;

    if (userData != null && userData.email && userData.email.length > 0 && userData.email === email) {
      this.loginService.authenticate(userData, "");
      //this.router.navigateByUrl("/home/tabs/shop");
      return;
    }
    if (email === null || email.length === 0 || password.length === 0) {
      return;
    }
    let isEmailAccount: boolean = email.indexOf("@") != -1;
    if (isEmailAccount) {
      this.loginService.login(email, password).then((error) => {
        if (error.code === undefined) { return; }
        this.openError(error.code)
      });
    }
    else {
      //TODO authenticate with user name
      this.loginService.loginWithUser(email, password);
    }
  }
}
